// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import {
  hideListing,
  unhideListing
} from '../redux/main/actions/orgDashboard/listings';
import {
  hideGradProgram,
  unhideGradProgram
} from '../redux/main/actions/orgDashboard/gradPrograms';
import { pushFlashMessage } from '../redux/main/actions/flashMessages';

type OwnProps = {
  listingId: string,
  listingType: string,
  orgId: string,
  render: ({
    hideListing: () => Promise<void>,
    unhideListing: () => Promise<void>,
    submitting: boolean
  }) => React.Node,
  onHide?: Function
};

type Props = {
  ...$Exact<OwnProps>,
  hideGradProgram: Function,
  unhideGradProgram: Function,
  hideListing: Function,
  unhideListing: Function,
  pushFlashMessage: Function
};

type State = {
  submitting: boolean
};

class HideListingContainer extends React.PureComponent<Props, State> {
  state = {
    submitting: false
  };

  toggleListingHidden = (hide: boolean) => {
    let toggle;
    this.setState({ submitting: true });
    const { orgId, listingId, listingType } = this.props;
    // @NOTE - We have to use grad program specific redux functions,
    // though it'd be preferable to treat grad programs the same as listings
    if (listingType === 'GRAD_PROGRAM') {
      toggle = hide ? this.props.hideGradProgram : this.props.unhideGradProgram;
    } else {
      toggle = hide ? this.props.hideListing : this.props.unhideListing;
    }
    return toggle({ orgId, listingId, listingType }).then(() => {
      this.setState({ submitting: false });
      this.props.pushFlashMessage({
        type: hide ? 'LISTING_HIDDEN' : 'LISTING_UNHIDDEN'
      });
      if (this.props.onHide) {
        this.props.onHide(hide ? 'LISTING_HIDDEN' : 'LISTING_UNHIDDEN');
      }
    });
  };

  hideListing = () => this.toggleListingHidden(true);

  unhideListing = () => this.toggleListingHidden(false);

  render() {
    const submitting = this.state.submitting;
    return this.props.render({
      hideListing: this.hideListing,
      unhideListing: this.unhideListing,
      submitting
    });
  }
}

export default connect<Props, OwnProps, _, _, _, _>(
  null,
  {
    hideListing,
    unhideListing,
    hideGradProgram,
    unhideGradProgram,
    pushFlashMessage
  }
)(HideListingContainer);
